import JwtPayload from '@/entities/api/jwt'
import { SESSION_KEY } from '@/entities/app/keys'

interface SessionData {
	token: string
	id: string
	data: JwtPayload
}

export const saveSession = (data: SessionData): void => {
	localStorage.setItem(SESSION_KEY, JSON.stringify(data))
}

export const getSession = (): SessionData | null => {
	const storedData = localStorage.getItem(SESSION_KEY)
	if (storedData) {
		return JSON.parse(storedData) as SessionData
	}
	return null
}

export const updateSession = (dataUpdate: Partial<JwtPayload>): void => {
	const getData = getSession()
	if (!getData) {
		console.error('Somenthing went wrong to get data from local storage')
		return
	}
	const { token, id, data } = getData
	const updateSession: SessionData = {
		token,
		id,
		data: {
			...data,
			...dataUpdate,
		},
	}

	saveSession(updateSession)
	return
}

export const closeSession = (): void => {
	localStorage.removeItem(SESSION_KEY)
}
